import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=f0198566&scoped=true&"
import script from "./banner.js?vue&type=script&lang=js&"
export * from "./banner.js?vue&type=script&lang=js&"
import style0 from "./banner.vue?vue&type=style&index=0&id=f0198566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0198566",
  null
  
)

export default component.exports